import {
	BiUpArrowCircle,
	BiBadgeCheck,
	BiExit,
	BiSolidContact,
	BiCheckCircle,
	BiSearchAlt2,
	BiMessageCheck
} from "react-icons/bi";
import { SidebarList } from "../@types/sidebar.types";

export const CUSTOM_SIDEBAR_ITEMS: SidebarList[] = [
	{
		redirect: "/",
		icon: BiUpArrowCircle,
		listValue: "Solution"
	},
	{
		redirect: "/",
		icon: BiBadgeCheck,
		listValue: "Nexcaliber Advantage"
	},
	{
		redirect: "/eligibility-check",
		icon: BiCheckCircle,
		listValue: "Eligibility Check"
	},
	{
		redirect: "/claim-status",
		icon: BiMessageCheck,
		listValue: "Claim Status"
	},
	{
		redirect: "/provider-search",
		icon: BiSearchAlt2,
		listValue: "Search Provider"
	},
	{
		redirect: "/contact",
		icon: BiSolidContact,
		listValue: "Contact Us"
	},
	{
		redirect: "https://admin.enrollment.nexcaliber.com/",
		icon: BiExit,
		listValue: "Member Login"
	}
];
